import { render } from "./QuestionOneScreen.vue?vue&type=template&id=74de8fb4&scoped=true&lang=html"
import script from "./QuestionOneScreen.vue?vue&type=script&lang=js"
export * from "./QuestionOneScreen.vue?vue&type=script&lang=js"

import "./QuestionOneScreen.vue?vue&type=style&index=0&id=74de8fb4&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74de8fb4"]])

export default __exports__